// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"eff8919b","736":"f8d0195a"}[chunkId] + ".chunk.css";
};